import {
  BANK_ACCOUNT_LIST_ATTEMPT,
  BANK_ACCOUNT_LIST_SUCCESS,
  BANK_ACCOUNT_LIST_FAILED,
  ///////////////////////
  BANK_ACCOUNT_SAVE_ATTEMPT,
  BANK_ACCOUNT_SAVE_SUCCESS,
  BANK_ACCOUNT_SAVE_FAILED,
} from "../types/bankAccountTypes";

const INITIAL_STATE = {
  loading: false,
  saving: false,
  list: [],
  max: 5,
  error: "",
};

function bankAccount(state = INITIAL_STATE, action) {
  switch (action.type) {
    case BANK_ACCOUNT_LIST_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case BANK_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data.list || [],
        max: action.data.max || 5,
        error: "",
      };

    case BANK_ACCOUNT_LIST_FAILED:
      return { ...state, loading: false, error: action.error };

    case BANK_ACCOUNT_SAVE_ATTEMPT:
      return { ...state, saving: true, error: "" };

    case BANK_ACCOUNT_SAVE_SUCCESS:
      return {
        ...state,
        saving: false,
        list: action.data.list || [],
        max: action.data.max || state.max,
        error: "",
      };

    case BANK_ACCOUNT_SAVE_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
}

export default bankAccount;
